export const CATEGORIES = [
  { id: "all", label: "Tout l'inventaire" },
  { id: "remorques", label: "Remorques" },
  { id: "electriques", label: "Outils électriques" },
  { id: "coupe", label: "Outils de coupe" },
  { id: "beton", label: "Béton & maçonnerie" },
  { id: "fixation", label: "Cloueuses & fixation" },
  { id: "echelles", label: "Échelles & échafaudages" },
  { id: "main", label: "Outils à main" },
  { id: "levage", label: "Levage & manutention" },
  { id: "securite", label: "Sécurité" },
  { id: "mesure", label: "Mesure" },
  { id: "autre", label: "Autres" },
];
